/* unplugin-vue-components disabled */import { render } from "./QuizHtmlEditor.vue?vue&type=template&id=23bbd672&scoped=true&ts=true"
import script from "./QuizHtmlEditor.vue?vue&type=script&lang=ts"
export * from "./QuizHtmlEditor.vue?vue&type=script&lang=ts"

import "./QuizHtmlEditor.vue?vue&type=style&index=0&id=23bbd672&scoped=true&lang=scss"
import "./QuizHtmlEditor.vue?vue&type=style&index=1&id=23bbd672&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bbd672"]])

export default __exports__